import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaCheck } from "react-icons/fa";
import "../../styles/site.css";
import Header from "../Header/Header";
import Process from "../Process/Process";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import useSeo from "../../seo/useSeo";
import pages from "../../data/pages.json";
import "./ServicePage.css";

const ServicePage = ({ page }) => {
  useSeo(page);
  const others = pages.services.filter((s) => s.path !== page.path);

  return (
    <div className="lk-site">
      <Header />
      <main>
        <section className="lk-page-hero">
          <div className="lk-container">
            <nav className="lk-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span aria-hidden="true">/</span>
              <span>{page.name}</span>
            </nav>
            <div className="lk-eyebrow">{page.eyebrow}</div>
            <h1 className="lk-page-title">{page.h1}</h1>
            <p className="lk-page-intro">{page.intro}</p>
            <div className="lk-hero-actions">
              <a href="#contact" className="lk-btn lk-btn-primary">
                Get a fixed-price quote
                <FaArrowRight aria-hidden="true" />
              </a>
            </div>
          </div>
        </section>

        <section className="lk-section lk-section-alt">
          <div className="lk-container">
            <h2 className="lk-h2">{page.includedTitle}</h2>
            <div className="lk-page-grid">
              {page.included.map((item) => (
                <div key={item.title} className="lk-card lk-page-item">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="lk-section">
          <div className="lk-container lk-page-split">
            <div>
              <h2 className="lk-h2">{page.goodForTitle}</h2>
              <ul className="lk-page-fit">
                {page.goodFor.map((item) => (
                  <li key={item}>
                    <FaCheck aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="lk-h2">Common questions</h2>
              <div className="lk-faq">
                {page.faq.map((item) => (
                  <details key={item.q}>
                    <summary>{item.q}</summary>
                    <p>{item.a}</p>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>

        <Process />
        <Contact defaultService={page.service} />

        <section className="lk-section lk-page-more">
          <div className="lk-container">
            <h2 className="lk-h2">Other services</h2>
            <ul className="lk-page-links">
              {others.map((s) => (
                <li key={s.path}>
                  <Link to={s.path}>
                    {s.name}
                    <FaArrowRight aria-hidden="true" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ServicePage;
